import { useGetUserEmploymentsQuery } from 'app/api_v2/employments/queries';
import { useAuthStore } from 'app/core/store_v2/auth';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import LinesSkeleton from 'app/ui_v2/components/skeletons/lines-skeleton/LinesSkeleton';
import AgencyProfileIcon from 'app/ui_v2/icons/AgencyProfileIcon';
import ArrowRightIcon from 'app/ui_v2/icons/ArrowRightIcon';
import { Link, Navigate } from 'react-router-dom';

import { Box, ButtonBase, Card, CardContent, Container, Typography, useTheme } from '@mui/material';

export default function AgencyGetDefaultProfile() {
  const { currentUser } = useAuthStore();

  const theme = useTheme();
  const { isRefetching, isLoading, data, error, isError } = useGetUserEmploymentsQuery({
    user_id: currentUser?.id || '',
  });

  if (data && data.length === 0) {
    console.error('No company found');
    return <Navigate to={`/agency/dashboard`} />;
  }

  if (data && data.length === 1) {
    return <Navigate to={`/agency/${data[0].companyId}/main`} />;
  }

  return (
    <Container maxWidth="lg" className="disable-center">
      <Box pt={4} pb={2}>
        <Typography component="h2" variant="h1" className="is-with-indicator">
          Agency profiles
        </Typography>
      </Box>

      {isLoading && (
        <Box my={2}>
          <LinesSkeleton elements={2} spacing={2} isWithButtons={false} lineHeight={90} />
        </Box>
      )}

      {data &&
        data.map((employment) => (
          <ButtonBase
            component={Link}
            to={`/agency/${employment.companyId}/main`}
            key={employment.id}
            sx={{ width: '100%', mb: 2 }}
          >
            <Card sx={{ m: 0, width: '100%' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '40px',
                      height: '40px',
                      border: '1px solid ' + theme.palette.primary.dark,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                      color: theme.palette.primary.dark,
                      mr: 2,
                    }}
                  >
                    <AgencyProfileIcon />
                  </Box>
                  <Box
                    sx={{
                      fontSize: '2.2rem',
                      textTransform: 'uppercase',
                      color: theme.palette.primary.light,
                      fontWeight: 500,
                      flex: 1,
                    }}
                  >
                    {employment?.company?.name || 'DRAFT'}
                  </Box>
                  <Box
                    sx={{
                      width: '40px',
                      height: '40px',
                      background: theme.palette.primary.dark,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                      color: theme.palette.common.white,
                      ml: 2,
                    }}
                  >
                    <ArrowRightIcon />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </ButtonBase>
        ))}

      {isRefetching && (
        <Box my={2}>
          <LinesSkeleton elements={1} spacing={2} isWithButtons={false} lineHeight={90} />
        </Box>
      )}

      {isError && error && <ErrorsList title="Unexpected error" errors={error as string[]} />}
    </Container>
  );
}
